<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛项评审管理</el-breadcrumb-item>
      <el-breadcrumb-item>赛事评委库</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4" style="width:360px !important;margin-right: 20px;">
          <el-select v-model="queryInfo.MatchID" placeholder="请选择赛项名称" clearable @clear="getJudgeLibList(1)"
                     @change="selectGettrack(queryInfo.MatchID, 0)" style="width:360px !important;">
            <el-option v-for="item in matchNameoptions" :key="item.MatchID" :label="item.MatchName" :value="item.MatchID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="queryInfo.Status" placeholder="请选择分配状态" clearable @clear="getJudgeLibList(1)">
            <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="请输入搜索内容" v-model="queryInfo.SearchContent" clearable @clear="getJudgeLibList(1)">
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button icon="el-icon-search" type="primary" @click="getJudgeLibList(1)">搜索</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="showEditCreate('add')">添加评委</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="success" @click="exportgo()">导入评委</el-button>
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="JudgesCode" label="评委编号"> </el-table-column>
        <el-table-column prop="LoginID" label="评委账号"> </el-table-column>
        <el-table-column prop="JudgesName" label="评委姓名"> </el-table-column>
        <el-table-column prop="Telephone" label="手机号"> </el-table-column>
        <el-table-column prop="AffiliatedUnit" label="所属单位"> </el-table-column>
        <el-table-column prop="JudgesGroupList" label="所属小组">
          <template slot-scope="scope">
            <div>
              <el-tag size="mini" v-for="item in scope.row.JudgesGroupList" :key="item.JudgesGroupID" class="proftag"
                      type="warning">{{ item.JudgesGroupName }}
                <span class="el-icon-success" v-if="item.Role == 1"></span>
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="AddTime" label="添加日期" :formatter="dataFormat">
        </el-table-column>
        <el-table-column label="操作" width="390">
          <template slot-scope="scope">
            <el-button type="success" icon="el-icon-edit" size="mini" @click="teamSet(scope.row)">组长设置</el-button>
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditCreate('edit', scope.row)">修改</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteCreate(scope.row.JudgesID)">删除</el-button>
            <el-button type="warning" icon="el-icon-key" size="mini" @click="resetPwd(scope.row.JudgesID)">重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum"
                     :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"
                     background>
      </el-pagination>
      <!-- 修改 -->
      <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible" width="35%" @close="editresetFields">
        <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="100px">
          <el-form-item label="赛事名称" prop="MatchID">
            <el-select v-model="editForm.MatchID" placeholder="请选择" style="width: 360px !important">
              <el-option v-for="item in matchNameoptions2" :key="item.MatchID" :label="item.MatchName" :value="item.MatchID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="评委账号" prop="LoginID">
            <el-input v-model="editForm.LoginID" placeholder="请输入评委账号" :disabled="userstatus"></el-input>
          </el-form-item>
          <el-form-item label="评委密码" prop="JudgesPwd" v-if="!userstatus">
            <el-input v-model="editForm.JudgesPwd" placeholder="请输入评委密码"></el-input>
          </el-form-item>
          <el-form-item label="评委姓名" prop="JudgesName">
            <el-input v-model="editForm.JudgesName" placeholder="请输入评委姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="editForm.Telephone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="所在单位">
            <el-select v-model="editForm.SchoolID" filterable placeholder="请选择" @change="handlerSelect" style="width: 370px !important">
              <el-option v-for="item in AffiliatedUnitOptions" :key="item.SchoolID" :label="item.SchoolName" :value="item.SchoolID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editCreate()">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 是否设置为组长 -->
      <el-dialog title="设置组长" :visible.sync="switchDialogVisible" width="50%">
        <div class="infotext">
          评委编号:{{ this.JudgesCode }} &nbsp;&nbsp;&nbsp;&nbsp;评委姓名：{{
            this.JudgesName
          }}
        </div>
        <el-table :data="groupData" border style="width: 100%">
          <el-table-column prop="MatchName" label="赛事名称"> </el-table-column>
          <el-table-column prop="TrackName" label="赛道名称"> </el-table-column>
          <el-table-column prop="JudgesGroupName" label="所属小组">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-switch class="groupState" active-text="是否为组长" :value="
                  scope.row.Role === 1
                    ? (groupState = true)
                    : (groupState = false)
                " @change="changeGroupState(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- 导入评委 -->
      <el-dialog title="导入评委账号" :visible.sync="judgelibshow" width="30%">
        <el-form :model="judgelibForm" ref="judgelibFormRef" label-width="100px" :rules="rules">
          <el-form-item label="模板文件" prop="tempFile">
            <el-upload class="avatar-uploader" ref="uploadref" action="uploadUrlAPI" :limit="1" :on-exceed="handleExceed" :show-file-list="false"
                       :on-change="uploadChange" :on-success="handleAvatarSuccess" :auto-upload="false" :file-list="fileList" accept=".xls,.xlsx">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip" style="color: #666">
                只能上传.xls,.xlsx文件，且不超过50MB
              </div>
            </el-upload>
            <div v-if="judgelibForm.tempFile">
              <a :href="judgelibForm.tempFile"><img src="@/assets/excel.png" alt="excel" /></a>
              <el-button @click="removeFile" size="mini" type="warning" style="position: relative; top: -10px; margin-left: 10px">移除</el-button>
            </div>
            <div class="downfile">
              <a href="../../../file/评审专家名单模板.xlsx" download style="color: green">评审专家名单模板</a>
              <p style="color: #666">
                格式说明：<br />
                1、请按示例模板进行修改<br />
                2、请勿修改模板结构，否则可能导致添加模板失败
              </p>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    // 自定义验证规则
    var rulePhone = (rule, value, cb) => {
      // 手机号正则
      const regMobile =
        /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (regMobile.test(value)) {
        return cb() // 验证合法有效
      }
      cb(new Error('请输入合法手机号'))
    }
    var isChinese = (rule, value, cb) => {
      // 不能使用中文正则
      const regChinese = /^[^\u4e00-\u9fa5]*$/
      if (!regChinese.test(value)) {
        cb(new Error('账号不能使用中文'))
      } else {
        cb()
      }
    }
    return {
      // 获取列表
      queryInfo: {
        MatchID: '',
        // 查询参数
        matchName: '',
        // 分配状态
        Status: '',
        // 搜索
        SearchContent: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,
      // 添加弹框显示状态
      addDialogVisible: false,
      // 修改弹框显示状态
      editDialogVisible: false,
      // 设置组长弹框显示状态
      switchDialogVisible: false,
      // 导入评委账号弹框显示状态
      judgelibshow: false,
      fileList: [],
      judgelibForm: {
        tempFile: ''
      },
      rules: {
        tempFile: [
          {
            required: true,
            message: '此字段为必填',
            trigger: 'change'
          }
        ]
      },
      // 弹窗默认标题
      dialogTitle: '',
      // 添加表单
      editForm: {
        MatchID: '',
        JudgesName: '',
        Telephone: '',
        LoginID: '',
        AffiliatedUnit: '',
        SchoolID: ''
      },
      // 修改表单验证
      editRules: {
        MatchID: [
          {
            required: true,
            message: '请输入选择赛道名称',
            trigger: 'change'
          }
        ],
        LoginID: [
          {
            required: true,
            message: '请输入评委账号',
            trigger: 'blur'
          },
          {
            validator: isChinese,
            trigger: 'blur'
          },
          { min: 10, max: 30, message: '长度在 10 到30 个字符', trigger: 'blur' }
        ],
        JudgesPwd: [
          {
            required: true,
            message: '请输入评委密码',
            trigger: 'blur'
          }
        ],
        JudgesName: [
          {
            required: true,
            message: '请输入评委姓名',
            trigger: 'blur'
          }
        ],
        Telephone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: rulePhone,
            trigger: 'blur'
          }
        ],
        SchoolID: [
          {
            required: true,
            message: '请输入所在单位',
            trigger: 'blur'
          }
        ]
      },
      // 赛事名称下拉选项
      matchNameoptions: [
        {
          value: '1',
          label: '赛事1'
        },
        {
          value: '2',
          label: '赛事2'
        }
      ],
      // 赛事名称下拉选项2
      matchNameoptions2: [],
      // 分配状态下拉选项
      stateOptions: [
        {
          value: 1,
          label: '已分配'
        },
        {
          value: 0,
          label: '未分配'
        }
      ],
      //  是否设置为组长
      groupState: false,
      // 评委对应小组数据
      groupData: [],
      // 评委编号
      JudgesCode: '',
      // 评委姓名
      JudgesName: '',
      // 账号修改状态
      userstatus: false,
      // 所在单位下拉
      AffiliatedUnitOptions: [
        {
          value: '1',
          label: '北京大学'
        },
        {
          value: '2',
          label: '上海大学'
        }
      ]
    }
  },
  created() {
    //   默认获取列表
    this.getJudgeLibList(1)
    // 默认获取赛事
    this.getAllMatch()
    // 获取设置组长弹窗数据
    // this.getGroupData(row)
    // 获取所在单位
    this.getBelongs()
  },
  methods: {
    // 导入评委账号
    exportgo() {
      this.judgelibshow = true
    },
    handleSubmit() {
      this.$refs.judgelibFormRef.validate((valid) => {
        if (valid) {
          const ParameterModel = new FormData()
          ParameterModel.append('file', this.fileList[0].raw)
          console.log(ParameterModel)
          // 导入
          this.$http
            .post('api/Judges/ImportJudges', ParameterModel)
            .then(async (res) => {
              if (res.data.StatusCode === 1) {
                this.judgelibshow = false
                this.$message.success(res.data.Msg)
                this.getJudgeLibList(1)
              } else {
                this.$message.error(res.data.Msg)
                return false
              }
            })
        } else {
          console.log('验证未通过')
          return false
        }
      })
    },
    handleAvatarSuccess() {
      this.$message.success('成功')
    },
    uploadChange(file, fileList) {
      this.fileList = fileList
      var fileSize = file.size / 1024 / 1024 < 50
      if (!fileSize) {
        this.$message.warning('上传文件大小不能超过 50MB!')
        this.clearfile()
        return false
      }
      if (this.judgelibForm.tempFile === '') {
        this.judgelibForm.tempFile = URL.createObjectURL(file.raw)
      }
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]
      }
      return true
    },
    removeFile() {
      this.judgelibForm.tempFile = ''
      this.clearfile()
    },
    clearfile() {
      // 清空文件列表
      this.$refs.uploadref.clearFiles()
    },
    handleExceed(files, fileList) {
      this.$message.warning('最多可以上传1个文件')
    },
    //   获取列表
    async getJudgeLibList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get('api/Judges/GetAllJudges', {
        params: this.queryInfo
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.allJudges
      this.total = res.Data.total
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
      this.matchNameoptions2 = res.Data.matchs
    },
    // 下拉赛项获取对应赛道
    async selectGettrack(id) {
      const { data: res } = await this.$http.get('/api/Track/GetTracks', {
        params: { MatchID: id + 0 }
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.$set(this.queryInfo, 'TrackID', null)
      this.trackNameoptions = res.Data.tracks
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getJudgeLibList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.getJudgeLibList(newPage)
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.userstatus = false
      this.editForm = {
        LoginID: '',
        JudgesName: '',
        Telephone: ''
      }
      this.$refs.editFormRef.resetFields()
    },
    // 显示修改赛事弹窗
    showEditCreate(type, row) {
      if (type === 'add') {
        this.dialogTitle = '添加评委'
      } else if (type === 'edit') {
        this.$nextTick(() => {
          // 注意看这里
          this.dialogTitle = '编辑评委'
          this.userstatus = true
          this.editForm = JSON.parse(JSON.stringify(row))
        })
      }
      this.editDialogVisible = true
    },
    // 显示设置组长弹窗
    teamSet(row) {
      // 评委编号
      this.JudgesCode = row.JudgesCode
      // 评委姓名
      this.JudgesName = row.JudgesName
      this.getGroupData(row)
      this.switchDialogVisible = true
    },
    // 获取设置组长弹窗数据
    async getGroupData(row) {
      const { data: res } = await this.$http.get(
        '/api/Judges/GetJudgesGroupByJudgesID?judgesId=' + row.JudgesID
      )
      if (res.StatusCode !== 1) return this.$message.error('获取失败')
      this.groupData = res.Data.judgesGroups
    },
    // 修改
    editCreate() {
      this.$refs.editFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/Judges/EditJudges',
          this.editForm
        )
        console.log(res)
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.editDialogVisible = false
        // 刷新列表
        this.getJudgeLibList(1)
      })
    },
    // 删除
    async deleteCreate(id) {
      // 提示是否确认删除
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      const { data: resdel } = await this.$http.post(
        '/api/Judges/DeleteJudgess?judgesIds=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      // 刷新列表
      this.getJudgeLibList(1)
    },
    // 重置密码
    async resetPwd(id) {
      // 提示用户输入新密码，默认值为8888
      const res = await this.$prompt(
        '请输入重置密码，默认不填写，密码为：8888',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          defaultValue: '8888' // 设置默认值为8888
        }
      ).catch((err) => {
        return err // 如果用户取消，返回 null
      })
      console.log(res)
      // 如果用户没有输入新密码（例如点击了取消按钮）
      if (res.action !== 'confirm') return this.$message.info('已取消重置密码')
      // 使用用户输入的新密码（如果用户输入了值）或默认值（如果用户没有输入值）
      const newPassword = res.value || '8888' // 如果value为空，则使用默认值8888
      // 发送请求
      const { data: resdel } = await this.$http.get(
        '/api/Judges/ResetJudgesPwd',
        {
          params: { JudgesID: id, newPwd: newPassword }
        }
      )
      if (resdel.StatusCode !== 1) return this.$message.error('重置密码失败')
      this.$message.success('重置密码成功')
    },
    // 修改组长状态
    async changeGroupState(row) {
      // 发起添加请求
      const { data: res } = await this.$http.post(
        '/api/Judges/SetJudgesRole?judgesId=' +
          row.JudgesID +
          '&JudgesGroupID=' +
          row.JudgesGroupID
      )
      // 判断状态码
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      // 成功提示
      this.$message.success(res.Msg)
      // 刷新列表
      this.getGroupData(row)
      // 获取列表
      this.getJudgeLibList(1)
    },
    // 获取所在单位
    async getBelongs() {
      const { data: res } = await this.$http.get('/api/School/GetAllSchoolName')
      this.AffiliatedUnitOptions = res.Data.schools
    },
    // 添加会员获取学校下拉当前选中的label值（学校名）
    handlerSelect(val) {
      if (val) {
        let obj = {}
        obj = this.AffiliatedUnitOptions.find((item) => {
          return item.SchoolID === val
        })
        this.editForm.AffiliatedUnit = obj.SchoolName
      }
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="less">
.groupState {
  margin-right: 10px;
}
.infotext {
  color: #999;
}
.box-card {
  .el-col {
    margin: 5px 0;
  }
}
</style>
